import React, { useState, useEffect } from "react";
import { Layout } from "antd";
import { useLocation } from "react-router-dom";
import Sidebar from "../Sidebar";
import Navbar from "../Navbar";
import "./style.css";

const { Content } = Layout;

const AppLayout = ({ children, setUser }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [pageTitle, setPageTitle] = useState("Dashboard");

  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;

    if (path.includes("/dashboard")) setPageTitle("Dashboard");
    else if (path.includes("/email-servers")) setPageTitle("Email Servers");
    else if (path.includes("/add-email-server"))
      setPageTitle("Add Email Servers");
    else if (path.includes("/edit-email-server"))
      setPageTitle("Edit Email Servers");
    else if (path.includes("/api-keys")) setPageTitle("API Keys");
    else if (path.includes("/create-api-key"))
      setPageTitle("Create New API Key");
    else if (path.includes("/api-key-generated"))
      setPageTitle("New API Key Generated");
    else if (path.includes("/payment-details")) setPageTitle("Payment Details");
    else if (path.includes("/pricing-plan")) setPageTitle("Pricing Plan");
    else if (path.includes("/profile")) setPageTitle("Profile Setting");
    else if (path.includes("/edit-profile")) setPageTitle("Edit Profile");
    else if (path.includes("/change-password")) setPageTitle("Change Password");
    else setPageTitle("Dashboard"); // default if no match
  }, [location.pathname]);

  return (
    <Layout style={{ minHeight: "100vh" }}>
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        breakpoint="md"
        setUser={setUser}
      />

      <Layout
        className="site-layout"
        style={{
          marginLeft: collapsed ? 0 : 240,
          transition: "margin-left 0.5s",
        }}
      >
        <Navbar
          title={pageTitle}
          collapsed={collapsed}
          setCollapsed={setCollapsed}
        />

        <Content>{children}</Content>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
